import { validateServerData } from '@wwt/core/admin'
import { SetResponseDto } from '@wwt/entities/api/search-response'

import { api } from '@/shared/api/client'

export const createSetQuery = async (title: string) => {
	// DEV: Add validation for correct create set
	const response = await api().post({ title }, '/v1/offers/sets').json()

	return validateServerData(response, SetResponseDto, 'Create set')
}
